import LabeledCheckbox from './LabeledCheckbox';

export default LabeledCheckbox;
